/// <reference path='walkinManagerDisplay.module.ts' />
/// <reference path='../../../../typings/index.d.ts' />

module Meevo.Plugins.WalkinManagerDisplay {

    const APPOINTMENT_UPDATE_INTERVAL = 15000;

    class WalkinManagerDisplayController {

        static $inject = [
            '$rootScope',
            '$interval',
            '$q',
            '$state',
            'meevo.AppSettings',
            'meevo.components.busy.BusyService',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.plugins.walkinManager.WalkinAppointmentService',
            'meevo.plugins.walkinManager.WalkInSettingsService'
        ];

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private refreshInterval: ng.IPromise<any>;

        constructor(
            protected $rootScope: angular.IRootScopeService,
            protected $interval: ng.IIntervalService,
            protected $q: ng.IQService,
            protected $state: angular.ui.IState,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected walkinAppointmentService: Meevo.Plugins.WalkinManager.IWalkinAppointmentService,
            protected walkInSettingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService
        ) {

            this.busyService.start();

            this.walkInSettingsService.fetchSettings()
                .then(() => {
                    this.getWalkInAppointments()
                        .finally(() => this.busyService.stop());
                })
                .catch(() => this.busyService.stop());

            this.refreshInterval = $interval(() => {
                this.getWalkInAppointments();
            }, APPOINTMENT_UPDATE_INTERVAL);
        }

        private getWalkInAppointments (): ng.IPromise<any> {
            return this.walkinAppointmentService.fetchWalkInAppointments(Meevo.Model.WaitListStatus.Default);
        }

        public closeContext(): void {
            this.$interval.cancel(this.refreshInterval);
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLOSE_CONTEXT, this.$state['current'], null);
        }

        exitDisplay(): void {
            let options = {
                templateUrl: 'app/plugins/walkinManagerKiosk/exitKiosk/exit.modal.html',
                controller: 'meevo.plugins.walkinManagerKiosk.exitKiosk.ExitKioskController',
                controllerAs: 'vm',
                bindToController: true,
                locals: {
                    oneTry: false,
                    isKiosk: false
                }
            };

            this.$interval.cancel(this.refreshInterval);
            this.modalService.showCustom(options)
                .then(() => {
                    this.closeContext();
                })
                .catch(() => {
                    this.refreshInterval = this.$interval(() => {
                        this.getWalkInAppointments();
                    }, APPOINTMENT_UPDATE_INTERVAL);
                });
        }
    }

    angular.module('meevo.plugins.walkinManagerDisplay')
        .controller('meevo.plugins.walkinManagerDisplay.walkinManagerDisplayController', WalkinManagerDisplayController);
}
